import { v4 as uuidv4 } from "uuid";
export class ClientUpdateAttachmentModel {
    constructor() {
        this.id = uuidv4();
        this.updateId = "";
        this.mediaFileId = null;
        this.url = null;
        this.label = null;
        this.fileUrl = null;
        this.createdOn = null;
        this.createdBy = null;
    }
}
export default class ClientUpdateAttachment extends ClientUpdateAttachmentModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
